import React from "react"
import Ample from "../components/ample"
import {formatCurrency, validateNumericInput} from "../components/utils"
import ReactDOM from 'react-dom'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import "../plugins/bower_components/chartist/chartist.min.css"
import GenericPopover from "../components/genericpopover"
import OptionPicker from "../components/optionpicker"
import moment from 'moment'


export default class OptionPricerPage extends React.Component {
  SortCol = {
    Strike:0, Price:1
  }
  SortDir = {
    Asc:0,Desc:1
  }
  state = {
    strike: "3725",
    iv: "0.1627",
    t : ".0002", days_to_expiration:"5",hours_to_expiration:"0",
    interest_rate: "0.011", //"0.0085",
    optionType:"1",
    underlying_price_start: "3700",
    underlying_price_end: "3750",
    underlying_price_step: "1",
    resultsVisible: false,
    pricedata:null,
    backdropActive:false,
    chainLoaderAnchorElement:null
  }
  componentDidMount() {
    this.setState({
      sort_col:this.SortCol.Strike,
      sort_dir:this.SortDir.Price,
      chainLoaderAnchorElement:document.getElementById("iv")
    })
  }

  validateInputField(field,allowZero=false,allowNeg=false) {
    const val = this.state[field].toString()
    return validateNumericInput(val, allowZero,allowNeg)
  }

  FormValid() { 
    return ( this.validateInputField('t') && this.validateInputField('strike') && this.validateInputField('iv') && this.validateInputField('days_to_expiration',true) && this.validateInputField('hours_to_expiration',true) 
            && this.validateInputField('underlying_price_start',true) && this.validateInputField('underlying_price_end',false) && this.validateInputField('underlying_price_step',false,true))
  }
  formReset = event => {
    this.setState({resultsVisible:false})
  }
  ivChanged = event => {
    this.setState({iv:event.target.value})
  }
  strikeChanged = event => {
    this.setState({strike:event.target.value})
  }
  dteChanged = event => {
    this.setState({days_to_expiration:event.target.value})
  }
  hteChanged = event => {
    this.setState({hours_to_expiration:event.target.value})
  }
  startChanged = event => {
    this.setState({underlying_price_start:event.target.value})
  }
  endChanged = event => {
    this.setState({underlying_price_end:event.target.value})
  }
  stepChanged = event => {
    this.setState({underlying_price_step:event.target.value})
  }
  optionTypeChanged = event => {
    this.setState({optionType:event.target.value})
  }
  activateBackdrop = () => {
    this.setState({backdropActive:true})
  }
  closeBackdrop = () => {
    this.setState({backdropActive:false})
  }
  computeDTE() {
    const input_days = parseFloat(this.state.days_to_expiration)
    const input_hours = parseFloat(this.state.hours_to_expiration)
    const hours_in_year = 365.0 * 24

    let total_hours = (input_days * 24) + input_hours
    let new_t = total_hours/hours_in_year
    this.setState({t:new_t})
  }
  componentDidUpdate(prevProps,prevState) {
    if (prevState.days_to_expiration!==this.state.days_to_expiration || prevState.hours_to_expiration!==this.state.hours_to_expiration) {
      //if the inputs have changed but we've *also* seen t change, that means we don't need to recompute t
      if (prevState.t===this.state.t) {
        this.computeDTE() 
      }
    }
  }
  formSubmitted = event => {
    this.setState({resultsVisible:false})
    this.activateBackdrop()
    Promise.all([this.requestOptionPriceData()])
      .then(()=>{
        this.sortData()
        this.renderOptionsTable()
        this.renderChart()
        this.setState({resultsVisible:true})
      }).then ( ()=> {this.closeBackdrop()} )
  }
  requestOptionPriceData() {
    const url = `https://api.harsip.com/strategies/pricer?strike=${this.state.strike}&iv=${this.state.iv}&t=${this.state.t}&interest_rate=${this.state.interest_rate}&optionType=${this.state.optionType}&underlying_price_start=${this.state.underlying_price_start}&underlying_price_end=${this.state.underlying_price_end}&underlying_price_step=${this.state.underlying_price_step}`
    return (fetch(url)
        .then(res => res.json())
        .then((data) => {
          //console.log('got option data')
          this.setState({ pricedata: data }) 
        })
      .catch(console.log))
  }
  sortData() {
    const col = this.state.sort_col
    const dir = this.state.sort_dir
    const data = this.state.pricedata

    switch (col) {
      case this.SortCol.Strike:
        if (dir === this.SortDir.Asc) {
          data.sort( (a,b) => b.underlying_price - a.underlying_price )
        } else {
          data.sort( (a,b) => a.underlying_price - b.underlying_price )
        }
        
        break
      default: //this.SortMode.Price:
        if (dir === this.SortDir.Asc) {
          data.sort( (a,b) => b.option_price - a.option_price )
        } else {
          data.sort( (a,b) => a.option_price - b.option_price )
        }
    }
    this.setState({pricedata:data})
  }
  renderOptionsTable()  {
    let data=this.state.pricedata
    let optionpricetable= (
        <table width="100%" className="table"  >
        <thead>
        <tr>
            <th className="border-top-0" onClick={() => this.requestSort(this.SortCol.Strike)}>Underlying&nbsp;<i className="fas fa-sort"></i></th>
            <th className="border-top-0" onClick={() => this.requestSort(this.SortCol.Price)}>Option&nbsp;<i className="fas fa-sort"></i></th>
            </tr>
        </thead>
        <tbody id="spreadRows">
        {
        data.map(p=> {
            return (<tr key={p.underlying_price}>
            
            <td>{formatCurrency(p.underlying_price)}</td>
            <td>{formatCurrency(p.option_price)}</td>
            
            </tr>)
        })
        }
        </tbody>
        </table>
    )
    ReactDOM.render(optionpricetable, document.getElementById('optionTable'));
  }
  requestSort = (col) => {
    let sort_dir = this.state.sort_dir;
    //if we're clicking the column that's already selected, reverse the sort direction
    if (col === this.state.sort_col)     sort_dir = (sort_dir === this.SortDir.Asc) ? this.SortDir.Desc : this.SortDir.Asc;
    this.setState({sort_col:col, sort_dir:sort_dir},
       ()=>{
        this.sortData();
        this.renderOptionsTable(); this.renderChart()
       })    
    }

  renderChart() {
    let pricedata = this.state.pricedata
    let price_series=     pricedata.map(p=>  { return  { x:p.underlying_price,y:p.option_price } })
    
    var chartdata = { series: [
        {name:'price',data:price_series}
    ]
      }
      if (typeof window == `undefined`) {
        return;
      }
      const Chartist = require("../plugins/bower_components/chartist/chartist.min.js")

    let chartOptions = { 
      fullWidth: true,
      height:500,
      axisX: {
        type: Chartist.AutoScaleAxis,
        scaleMinSpace: 100
        },
        axisY: {
            type: Chartist.AutoScaleAxis,

            labelInterpolationFnc: function(value) {
                return   formatCurrency(value)
            }
        }
      ,series: {
        'price': {showArea: false,showPoint: true,},
        
      }
    //  ,showLine:false
    }

    new Chartist.Line('.ct-chart', chartdata,chartOptions);
  }
  computeTfromExpiry(expiry) 
  {
    expiry=moment(expiry).add(16, 'hours')
    const now = moment()
    const days = expiry.diff(now, 'days')
    const hours = expiry.diff(now, 'hours') - (days*24)
    const minutes = expiry.diff(now, 'minutes')

    const minutes_in_year = 365.0 * 24 * 60
    const t = minutes / minutes_in_year
    this.setState({
      hours_to_expiration: hours,
      days_to_expiration: days,
      t:t
    }
    )
  }
  computeRangeFromChain(chain_bottom, chain_top, selected_strike,step) {
    const chain_length = chain_top - chain_bottom;
     //default to showing 20% of the entire chain
    let range_width = chain_length * .1
   
    let range_start = Math.floor(selected_strike - range_width);
    if (range_start<chain_bottom) range_start = chain_bottom;
    range_start = range_start - (range_start % step)

    let range_stop = Math.ceil(selected_strike + range_width);
    if (range_stop>chain_top) range_stop = chain_top;
    range_stop = range_stop - (range_stop % step)

    return { range_start:range_start,range_stop:range_stop }
  }
  handleIncomingStrikeData = strike_data => {
    const range = this.computeRangeFromChain(strike_data['min_strike'],strike_data['max_strike'],strike_data['strike'].strike,strike_data['step'])
    this.computeTfromExpiry(strike_data['expiry'])
    this.setState(
      {
        strike:strike_data['strike'].strike,
        iv:strike_data['strike'].impliedVolatility,
        underlying_price_start:range['range_start'],
        underlying_price_end:range['range_stop'],
        underlying_price_step:strike_data['step']
      }
    )
  }

  explainerBlurb =<div>
  Plot how the price of an option chages with respect to the underlying stock price
  </div>  


  render() {
      return (
        <Ample currPageTitle="Option Price Visualizer" explainerBlurb={this.explainerBlurb}>
        <Backdrop style={{zIndex:  1,color: '#fff',}} open={this.state.backdropActive}  >
          <CircularProgress color="inherit" />
        </Backdrop>
        
        <div className="white-box">
          <div className="row">
            <div className="col-lg-6 col-sm-12 col-md-6" style={{maxWidth:"400px"}}>
              <table>
                    <tbody>
                    <tr><th colSpan="3" ><InputLabel>Option Details:</InputLabel></th></tr>
                    <tr>
                      <td>
                        <TextField type="number" error={!this.validateInputField('strike')} required={true} style={{width: "120px"}} label="Strike" id="strike" value={this.state.strike} onChange={this.strikeChanged} variant="outlined" helperText="Option strike"/>
                      </td>
                      <td>
                        <TextField type="number" error={!this.validateInputField('iv')} style={{width: "120px"}} label="IV" id="iv" value={this.state.iv} onChange={this.ivChanged} variant="outlined" helperText="Implied vol."/>
                      </td>
                      <td>
                        <RadioGroup  value={this.state.optionType} onChange={this.optionTypeChanged} name="optionTypeSelector" id="optionTypeSelector">
                        <FormControlLabel  value="1" control={<Radio  />} label="Call"  />
                        <FormControlLabel value="2" control={<Radio />} label="Put" />
                        </RadioGroup>
                      </td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div className="col-lg-6 col-sm-12 col-md-6">
              <table>
                <tbody>
                <tr><th colSpan="2"><InputLabel>Time to Expiration:</InputLabel></th></tr>
                <tr>
                  <td><TextField type="number" error={!this.validateInputField('t') || !this.validateInputField('days_to_expiration',true)} style={{width: "60px"}} label="Days" id="days_to_expiry" value={this.state.days_to_expiration} onChange={this.dteChanged} variant="outlined"/></td>
                  <td><TextField type="number" error={!this.validateInputField('t')  || !this.validateInputField('hours_to_expiration',true)} style={{width: "60px"}} label="Hours" id="hours_to_expiry" value={this.state.hours_to_expiration} onChange={this.hteChanged} variant="outlined"/></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-sm-12 col-md-6"  style={{maxWidth:"400px"}}>
              <table>
                <tbody>
                <tr><th colSpan="3"><InputLabel>Underlying Stock's Price Range:</InputLabel></th></tr>
                <tr>
                  <td><TextField type="number" error={!this.validateInputField('underlying_price_start',true)} style={{width: "120px"}} label="From" id="underlying_price_start" value={this.state.underlying_price_start} variant="outlined"  onChange={this.startChanged}/></td>
                  <td><TextField type="number" error={!this.validateInputField('underlying_price_end',false)} style={{width: "120px"}} label="To" id="underlying_price_end" value={this.state.underlying_price_end} variant="outlined" onChange={this.endChanged}/></td>
                  <td><TextField type="number" error={!this.validateInputField('underlying_price_step',false,true)} style={{width: "120px"}} label="Step" id="underlying_price_step" value={this.state.underlying_price_step} variant="outlined" onChange={this.stepChanged} /></td>
                </tr>
                </tbody>
              </table>
            </div>
            <div className="col-lg-6 col-sm-12 col-md-6">
              <GenericPopover triggerIcon={<i className="fas fa-link"></i>} callToAction="Load from chain" minWidth="600px" externalAnchorElement={this.state.chainLoaderAnchorElement}>
                <OptionPicker onStrikeSelected={this.handleIncomingStrikeData} />  
              </GenericPopover>
            </div>
          </div>
            
            
        <div className="row">  
          <div className="col-lg-12 col-sm-12 col-md-12"  >      
            <button disabled={!this.FormValid()} id="go" onClick={this.formSubmitted}  type="submit"  className="btn btn-rounded btn-default btn-outline">
                <i className="fas fa-play-circle  m-r-5"></i>Show</button>
              <button disabled={!this.state.resultsVisible} id="clear" onClick={this.formReset} className="btn btn-rounded btn-default btn-outline" >
                <i className="fas fa-eraser  m-r-5"></i>Clear</button>
          </div>
        </div>
      </div>
      <br />
      <div className="row justify-content-center">

        <div className="col-lg-6 col-sm-12 col-xs-12">
            <div className="white-box " id="optionTableContainer" style={{visibility:(this.state.resultsVisible)?'visible':'hidden'}}>
                <h3 className="box-title mb-0">Prices</h3>
                <div id="optionTable" className="table-responsive"></div>
            </div>
        </div>

        <div className="col-lg-6 col-sm-12 col-xs-12">
            <div className="white-box " id="optionChartContainer" style={{visibility:(this.state.resultsVisible)?'visible':'hidden'}}>
                <div id="chartArea" className="ct-chart"></div>
            </div>
        </div>
      </div>
    </Ample>
    )
  }
}



